export default __webpack_public_path__ + "static/media/notification.a6548c97.mp3";